/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const DropboxIconConfig = {
  name: 'DropboxIcon',
  height: 512,
  width: 528,
  svgPath: 'M264.4 116.3l-132 84.3 132 84.3-132 84.3L0 284.1l132.3-84.3L0 116.3 132.3 32l132.1 84.3zM131.6 395.7l132-84.3 132 84.3-132 84.3-132-84.3zm132.8-111.6l132-84.3-132-83.6L395.7 32 528 116.3l-132.3 84.3L528 284.8l-132.3 84.3-131.3-85z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(DropboxIconConfig);